import { render, staticRenderFns } from "./EditTerm.vue?vue&type=template&id=69d3fb2c&"
import script from "./EditTerm.vue?vue&type=script&lang=ts&"
export * from "./EditTerm.vue?vue&type=script&lang=ts&"
import style0 from "./EditTerm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports